import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PriceRule, PriceRuleCartSetting } from '@app/models/price-rule';
import { AppService } from '@shared/services/app.service';
import { PriceRuleViewComponent } from '@app/modules/price-rule/price-rule-view/price-rule-view.component';
import { MenuItem } from 'primeng/api/menuitem';
import { PriceRuleRepository } from '@app/@core/repositories/price-rule.repository';
import { PriceRuleEditDialogComponent } from '@app/modules/price-rule/price-rule-edit-dialog/price-rule-edit-dialog.component';

@Component({
  selector: 'app-course-price-rule-table',
  templateUrl: './course-price-rule-table.component.html',
  styles: []
})
export class CoursePriceRuleTableComponent {
  @Input() rows: PriceRule[] = [];
  @Input() showInstruction = true;
  @Output() dataChanged = new EventEmitter<string>();

  loading = false;
  cartSetting: PriceRuleCartSetting;

  selectedPriceRuleForExecutingAction: PriceRule;

  // Define action menu items for split button
  actionButtons: MenuItem[] = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.onEditPriceRule()
    },
    {
      label: 'Copy',
      icon: 'pi pi-copy',
      command: () => this.onCopyPriceRule()
    },
    {
      label: 'Sync to Slots',
      icon: 'pi pi-refresh',
      command: () => this.onSyncPriceToSlots()
    }
  ];

  constructor(
    private app: AppService,
    private priceRuleRepository: PriceRuleRepository
  ) {}

  // Open dialog for editing a price rule
  onEditPriceRule(): void {
    const { id } = this.selectedPriceRuleForExecutingAction;
    this.app.showDialog(
      PriceRuleEditDialogComponent,
      'Price Rule Edit',
      { id, showInstruction: this.showInstruction },
      { width: '1000px', height: '100vh' }
    ).onClose.subscribe((result: { action: string, priceRule: PriceRule }) => {
      if (result?.action) {
        this.dataChanged.emit(result.priceRule?.id);
      }
    });
  }

  // Duplicate a price rule and open dialog for editing the copy
  onCopyPriceRule() {
    const { id } = this.selectedPriceRuleForExecutingAction;
    this.app.confirm(
      'Duplicate this price rule and create a new one?',
      () => {
        this.app.showDialog(
          PriceRuleEditDialogComponent,
          'New Price Rule via Duplicate',
          { showInstruction: this.showInstruction, id: 'new', copyFromId: id },
          { width: '1000px', height: '95vh' }
        ).onClose.subscribe((result: { action: string, priceRule: PriceRule }) => {
          if (result?.action) {
            this.dataChanged.emit(result.priceRule?.id);
          }
        });
      },
      true
    );
  }

  // Open dialog for viewing a price rule
  onViewPriceRule(priceRule: PriceRule) {
    this.app.showDialog(
      PriceRuleViewComponent,
      'Price Rule Detail',
      { priceRule },
      { width: '70rem', height: '95vh' }
    );
  }

  // Sync the selected price rule to all slots
  onSyncPriceToSlots() {
    this.app.confirm(
      'Are you sure you want to sync this price rule to all slots? This will overwrite existing pricing in affected slots?',
      () => {
        const priceRuleId = this.selectedPriceRuleForExecutingAction.id;
        this.priceRuleRepository.applyNewPrice({ priceRuleId }).subscribe((affects) => {
          this.app.toastSuccess(`Updated ${affects} slots with new price rule.`);
        });
      },
      true
    );
  }

  // Set the selected price rule for action menu
  handleActionsClick(priceRule: PriceRule) {
    this.selectedPriceRuleForExecutingAction = priceRule;
  }
}
